var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-[#ffb3c7] rounded-[0.3rem]"},[_c('Illustration',{staticClass:"block h-full w-full mx-auto",attrs:{"alt":"","height":40,"src":_vm.$static(_vm.icon),"width":40}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }